<template>
  <div>
    <el-card>
        <el-row>
            <el-col :span="2" class="lableforP"><span>宿舍号：</span></el-col>
            <el-col :span="2"><el-input v-model="searRoom"></el-input></el-col>
            <el-col :span="1"></el-col>
            <el-col :span="2" class="lableforP"><span>填写时间：</span></el-col>
            <el-col :span="2"><el-input v-model="searDate"></el-input></el-col>
            <el-col :span="2"><el-button type="success" @click="searDorm">搜索</el-button></el-col>
        </el-row>
        <el-table  :data="resultDate" border show-overflow-tooltip="true" tooltip-effect="dark"
        style="width: 100%">
        <el-table-column prop="message" :show-overflow-tooltip="true" label="留言" width="110">
        </el-table-column>
        <el-table-column prop="roomId" :show-overflow-tooltip="true" label="宿舍号" width="180">
        </el-table-column>
        <el-table-column prop="createDate" :show-overflow-tooltip="true" label="填写时间" width="180">
        </el-table-column>
        <el-table-column prop="name" :show-overflow-tooltip="true" label="提交人姓名" width="150">
        </el-table-column>
 <el-table-column
      label="查看"
      width="110">
        <template slot-scope="scope" >
<el-button   @click="showsDorm(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-chakan2"></use></svg></el-button>
      </template>
    </el-table-column>

    <el-table-column
      label="打分"
      width="80">
        <template slot-scope="scope" >
            <el-input :readonly="scope.row.isMark" oninput="if(value.length>5)value=value.slice(0,5)" type="number"  v-model="scope.row.mark"></el-input>
      </template>
    </el-table-column>
    <el-table-column
      label="留言"
      width="80">
        <template slot-scope="scope" >
            <el-tooltip class="item" effect="dark" :content="scope.row.teacherMessage" placement="top">
                <el-input :readonly="scope.row.isMark" oninput="if(value.length>255)value=value.slice(0,255)" v-model="scope.row.teacherMessage"></el-input>

    </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column
      label="提交"
      width="80">
        <template slot-scope="scope" >
<el-button type="success" :disabled="scope.row.isMark"   @click="subUpdateDorm(scope.row)">提交</el-button>
      </template>
    </el-table-column>
    <el-table-column
    label="查看成员"
    width="80">
      <template slot-scope="scope">
<el-button type="success" @click="viewUser(scope.row.roomId)">查看</el-button>
      </template>
    </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
   title="查看查寝信息"
   :visible.sync="showRooms"
   :before-close="handleClose"
   width="50%">
   <el-form  label-width="200px" class="demo-dynamic">
     <el-form-item label="留言：">
     <el-input disabled  v-model="showRoom.message"></el-input>
   </el-form-item>
   <el-form-item label="宿舍号：" >
     <el-input disabled  v-model="showRoom.roomId">
    </el-input>
   </el-form-item>
   <el-form-item label="查看时间：">
     <el-input disabled  v-model="showRoom.createDate">
    </el-input>
   </el-form-item>
   <el-form-item label="提交人姓名：" >
     <el-input disabled  v-model="showRoom.name">
    </el-input>
   </el-form-item>
   <el-form-item label="打分" >
     <el-input  :disabled="showRoom.isMark" v-model="showRoom.mark" oninput="if(value.length>5)value=value.slice(0,5)" type="number">
    </el-input>
   </el-form-item>
   <el-form-item label="留言" >
     <el-input :disabled="showRoom.isMark" v-model="showRoom.teacherMessage" oninput="if(value.length>255)value=value.slice(0,255)">
    </el-input>
   </el-form-item>
 </el-form>
 <div class="imageClass">
 <div v-for="(item, index) in fileListResult"  :key="index + ''">
  <el-image 
    style="width: 150px; height: 150px"
    :src="item"
    :preview-src-list="fileListResult">
  </el-image>
</div>
</div>
<el-button type="success" v-if="!showRoom.isMark" @click="subUpdateDorm2" style="margin-top: 20px;">提交</el-button>
</el-dialog>

<el-dialog
  title="宿舍成员"
  :visible.sync="viewUserById"
  width="50%"
 >

 <el-table :data="userResult" border style="width: 100%" show-overflow-tooltip="true" tooltip-effect="dark"
       >
        <el-table-column prop="username" label="用户名" width="180">
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="180">
        </el-table-column>
        <el-table-column prop="email" label="邮箱" width="180">
        </el-table-column>
        <el-table-column prop="mobiles" label="手机号" width="180">
        </el-table-column>
        <el-table-column prop="studentID" label="学号" width="180">
        </el-table-column>
        <el-table-column prop="addType" label="是否为班干部" width="180" :formatter="stateFormat">
        </el-table-column>
      </el-table>


</el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        return{
            resultDate:[],
            viewUserById:false,
            fileListResult:[],
            showRooms:false,
            searRoom:'',
            searDate:'',
            searList:[],
            userResult:[],
            showRoom:{
          message:'',
          roomId:'',
          createDate:'',
          fileList:[],
          name:'',
          teacherMessage:'',
           mark:'',
          isMark:'',
          checkDormId:'',
        },
        teacherMessage:'',
          mark:'',
        }
    } , created(){
this.getDorm()
    },methods:{
        handleClose(done){
           this.fileListResult=[]
           done();
       },getDorm(){
                this.axios.post("/dorm/getDormByTeacherId?userId="+JSON.parse(localStorage.getItem("user")).userid)
          .then(resp => { 
            console.log(resp)
                        if(resp.data.status == 1) {
                          console.log(resp.data)
                                this.resultDate=resp.data.result
                                 }else {
                                  this.$message.error("获取数据失败")                         
                                 }
                             })
                             .catch((err) => {
                                 alert("出错了")
                                 console.log(err)
                             }) 
       },   stateFormat(row, column) {
    if (row.addType =='8') {
      return '是'
    } else  {
      return '否'
    } 
  },viewUser(data){
        console.log(data)
        this.axios.post("/user/getUserByRoomId?roomId="+data)
          .then(resp => { 
            console.log(resp)
                        if(resp.data.status == 1) {
                          console.log(resp.data)
                             this.viewUserById=true
                             this.userResult=resp.data.result
                                 }else {
                                  this.$message.error("获取数据失败")                         
                                 }
                             })
                             .catch((err) => {
                                 alert("出错了")
                                 console.log(err)
                             }) 

       },searDorm(){
       if( this.searList.length==0){
            this.searList=this.resultDate
          }
          this.resultDate=this.searList
       this.resultDate=this.resultDate.filter((item)=>{
          if(this.searDate!=''){
            // this.searDate==item.createDate.
    
            return item.createDate.includes(this.searDate)
          }else{
            return true
          }      
        })
        this.resultDate=this.resultDate.filter((item)=>{
          if(this.searRoom!=''){
            return this.searRoom==item.roomId
          }else{
            return true
          }      
        })
       },
       showsDorm(data){
        console.log(data)
        this.showRooms=true
        this.showRoom.message=data.message
         this.showRoom.roomId=data.roomId
          this.showRoom.createDate=data.createDate
          this.showRoom.name=data.name
          this.showRoom.mark=data.mark
          this.showRoom.isMark=data.isMark
          this.showRoom.teacherMessage=data.teacherMessage
          this.showRoom.checkDormId=data.checkDormId
          this.getFileList(data.checkDormId)
      },getFileList(useId){
  this.axios.post("/file/getFile?useId="+useId)
          .then(resp => { 
            console.log(resp)
                        if(resp.data.status == 1) {
                          this.fileListResult=[]
                          console.log(resp.data)
                                // this.fileListResult=resp.data.result
                                resp.data.result.forEach(item => {
                                  this.fileListResult.push(this.$imagepath+item.filePath)
                                });
                                console.log(this.fileListResult)
                                 }else {
                                  this.$message.error("获取数据失败")                         
                                 }
                             })
                             .catch((err) => {
                                 alert("出错了")
                                 console.log(err)
                             }) 
      },subUpdateDorm(data){
            if(data.mark==null){
            this.$message.error("请打分")
            return false
        }
        console.log(data)
        this.axios.post("/dorm/updateDorm",data)
          .then(resp => { 
            console.log(resp)
                        if(resp.data.status == 1) {
                          console.log(resp.data)
                        this.getDorm()
                            this.$message.success("提交成功")
                                 }else {
                                  this.$message.error("提交失败")                         
                                 }
                             })
                             .catch((err) => {
                                 alert("出错了")
                                 console.log(err)
                             }) 
      },subUpdateDorm2(){
        if(this.showRoom.mark==null){
            this.$message.error("请打分")
            return false
        }
        let data={
            "teacherMessage":this.showRoom.teacherMessage,
            "mark":this.showRoom.mark,
            "checkDormId":this.showRoom.checkDormId
        }
        this.axios.post("/dorm/updateDorm",data)
          .then(resp => { 
            console.log(resp)
                        if(resp.data.status == 1) {
                            this.showRooms=false
                          console.log(resp.data)
                        this.getDorm()
                            this.$message.success("提交成功")
                                 }else {
                                  this.$message.error("提交失败")                         
                                 }
                             })
                             .catch((err) => {
                                 alert("出错了")
                                 console.log(err)
                             }) 
      }
    }

}
</script>

<style>
.imageClass{
 white-space: nowrap;
 display: flex;
justify-content: space-evenly;
}
.lableforP{
      margin-top:8px;

    }
</style>


// WEBPACK FOOTER //
// src/components/work/instructor/viewStudentDorm.vue